var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", {
    staticClass: "idb-editor",
    attrs: { id: _vm.id },
    on: {
      paste: _vm.onPaste,
      keyup: function($event) {
        if (!$event.type.indexOf("key") && $event.keyCode !== 13) {
          return null
        }
        if (!$event.ctrlKey) {
          return null
        }
        return _vm.formatQuery($event)
      }
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }